var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"dialog-tab"},[_vm._l((_vm.tabs),function(item,index){return [_c('li',{key:index,class:{active: item.value == _vm.value},on:{"click":function($event){return _vm.handle(item.value)}}},[_vm._v(_vm._s(item.label))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }